export const changeAmountToFixed = (amount, fixedNumber) => {
    return +Number(amount).toFixed(fixedNumber)
}

export const convertBetValue = (chngAmt) => {
    let n = Number(chngAmt);

    if (n >= 1000 && n < 1_000_000) {
        n = Math.floor((n / 1000) * 100) / 100;  // truncate
        return n + "K";
    }
    else if (n >= 1_000_000 && n < 1_000_000_000) {
        n = Math.floor((n / 1_000_000) * 100) / 100;
        return n + "M";
    }
    else if (n >= 1_000_000_000) {
        n = Math.floor((n / 1_000_000_000) * 100) / 100;
        return n + "B";
    }

    return n;
};
